export default __webpack_public_path__ + "static/media/dominos.c91bfb0f.webp";